import { combineReducers } from 'redux';

import * as app from './app';
import * as markers from './markers';

function createRootReducer() {
  return combineReducers({ ...app, ...markers });
}

export default createRootReducer;
